<template>
    <div class="admin__popup popup__overplay">
        <div class="driver__popup">

            <div class="control-btn-container">
                <div class="btn" @click="saveProfile">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2">
                        <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                    </svg>
                    <p>Save Profile</p>
                </div>
                <div class="btn" @click="$emit('closePopup',userUpdated)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </div>
            </div>

            <div>
                <div class="popup__header">
                    <p>{{driverFirstname}} {{driverSurname}}</p>
                    <p>ID: {{driver.id}}</p>
                    <span :class="driver.status ? 'active__driver' : 'inactive__driver'">{{driver.status ? 'Active' : 'Inactivate'}}</span>
                </div>
            </div>

            <div class="driver__body">

                <div class="driver__information box__container box-shadow">
                    <p class="header">DRIVER INFORMATION</p>
                    <div class="driver__information__row flex row tablet__display">
                        <div style="width: 100%">
                            <div class="driver__sub__container">
                                <div class="driver__information__column personal__info" style="width: 100%">
                                    <p class="column__header">Personal info</p>
                                    <div>
                                        <div class="input__pair">
                                            <p>First Name</p>
                                            <input type="text" placeholder="eg. Jane" v-model="driverFirstname">
                                        </div>
                                        <div class="input__pair">
                                            <p>Last Name</p>
                                            <input type="text" placeholder="eg. Doe" v-model="driverSurname">
                                        </div>
                                        <div class="input__pair">
                                            <p>Email</p>
                                            <input type="text" placeholder="eg. myemail@myemail.com" disabled="disabled" v-model="driverEmail">
                                        </div>
                                        <div class="input__pair">
                                            <p>Phone Number</p>
                                            <input type="text" placeholder="123-456-7890" maxlength="50" v-model="driverPhoneNumber">
                                        </div>
                                        <div class="input__pair">
                                            <p>State</p>
                                            <select placeholder="State" class="input-filed" name="us state" v-model="driverState"  @change="checkStateCities" @blur="checkStateCities">
                                                <option disabled value="">Please select one</option>
                                                <option v-for="us_state in store.state.schema.US" v-bind:key="us_state.state">{{us_state.state}}</option>
                                            </select>
                                        </div>
                                        <div class="input__pair">
                                            <p>City</p>
                                            <select placeholder="City" class="input-filed selection__size" name="state cities" v-model="driverCity">
                                                <option disabled value="">Please select one</option>
                                                <option v-for="city in cities" v-bind:key="city">{{city}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="driver__information__column vehicle__info" style="width: 100%">
                                    <div class="vehicle__info-card">
                                        <p class="column__header">Vehicle Info</p>
                                        <div >
                                            <div>
                                                <div class="input__pair">
                                                    <p>Brand</p>
                                                    <select name="car brand" v-model="carBrand" @change="checkCarBrand" @blur="checkCarBrand">
                                                        <option v-for="car in schema.car_models" v-bind:key="car.Make">{{car.Make}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="input__pair">
                                                    <p>Model</p>
                                                    <select name="car models" v-model="carModel" :disabled="!carBrand">
                                                        <option v-for="model in carModels" v-bind:key="model">{{model}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="input__pair">
                                                <p>Year</p>
                                                <input type="text" :oninput="carYearRangeValue()" placeholder="eg. 2020" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" v-model="carYear" >
                                            </div>
                                            <div>
                                                <div>Color</div>
                                                <div id="color-pciker" style="35px">
                                                    <div class="wrapper-dropdown">
                                                        <span @click="toggleDropdown" v-html="selector()"></span>
                                                        <ul class="dropdown" v-if="colorDropdown">
                                                            <li v-for="color in colors" v-bind:key="color.name" @click="selectedColor(color.RGB, color.name)">
                                                            <span :style="{background: color.RGB}"></span>
                                                                {{color.name}}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="input__pair">
                                        <p>Status</p>
                                        <select placeholder="Status" class="input-filed" name="status" v-model="driverStatus" >
                                            <option disabled value="">Please select one</option>
                                            <option v-for="status in store.state.schema.driver_statuses" :key="status.id" :value="status.id">{{status.name}}</option>
                                        </select>
                                    </div>
                                    <div class="input__pair">
                                        <p>Registration</p>
                                        <input disabled v-model="driverRegistration" />
                                    </div>
                                </div>
                            </div>
                            <div class="driver__information__column">
                                <div class="input__pair">
                                <p>Notes</p>
                                <textarea type="text" v-model="driverNotes">
                                </textarea>
                            </div>
                            </div>
                        </div>
                        <div class="driver__sub__container">
                            <div class="driver__information__column driver__details" style="width: 100%">
                                <p class="column__header">Driving Details</p>
                                <div>
                                    <div class="input__pair">
                                        <p>How many hours do you drive weekly?</p>
                                        <input type="text" placeholder="eg. 80 Hours" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" :oninput="drivingHourRangeValue()" v-model="driverHours">
                                    </div>

                                    <div class="round__list__container">
                                        <p class="round__list__label">When do you usually drive?</p>
                                        <div class="time__list">
                                            <div v-for="(element, item) in schema.ride_time" @click="changeFlagValue(item, 1)" :key="item" class="rounded__item" :class="[timeFlags[item] ? 'button-checkbox-active' : '']">
                                                <p>{{element}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="round__list__container">
                                        <p class="round__list__label">What platform do you drive for?</p>
                                        <div class="platform__list">
                                            <div v-for="(element, item) in schema.transportation_platform" :key="item" @click="changeFlagValue(item, 2)" class="rounded__item" :class="[platformFlags[item] ? 'button-checkbox-active' : '']">
                                                <p>{{element}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="driver__sub__last-container">
                                        <div class="input__pair">
                                          <p>Installation</p>
                                          <input disabled class="datepicker"  v-model="driverInstallation" />
                                        </div>
                                        <div class="input__pair">
                                          <p>Last appointment</p>
                                          <v-date-picker
                                            mode="single"
                                            :masks="{ input: ['YYYY-MM-DD']}"
                                            :input-props='{class: "datepicker"}'
                                            v-model="driverLastAppointment"
                                          >
                                            <template v-slot="{ inputValue, inputEvents }">
                                                <input
                                                class="datepicker"
                                                readonly
                                                :value="inputValue + textLastAppointment"
                                                v-on="inputEvents"
                                                />
                                            </template>
                                          </v-date-picker>
                                        </div>
                                    </div>
                                    <driver-message :driver-id="driver.id" @sendMessage="sendDriverMessage" />
                                </div>
                            </div>
                            <div class="driver__information__column documents" style="width: auto; min-width: 270px;">
                                <p class="column__header">Documents</p>
                                <div>
                                    <div class="input__pair">
                                        <p>Picture of your driver license (front)</p>
                                        <div class="input__section">
                                            <div class="input__context">
                                                <div class="img__input__container">

                                                    <a  v-if="driverLicenceImage.name  && checkValidDoc(driverLicenceImage.name)" :href="driverLicenceImage.name" target="_blank" class="link__box">License image</a>
                                                    <input  v-if="!driverLicenceImage.name || !checkValidDoc(driverLicenceImage.name)"  class="input-filed" placeholder="eg. image.jpg" type="text" name="license picture" v-model="driverLicenceImage.name">

                                                    <img v-if="driverLicenceImage.name === undefined || driverLicenceImage.name.length === 0" src="./../../assets/nonUploadFile.png" alt="no-upload" class="btn-upload-file" @click="driverLicence">
                                                    <img v-if="driverLicenceImage.name !== undefined && driverLicenceImage.name.length > 0" src="./../../assets/okgreen.svg" alt="upload" class="btn-upload-file" @click="driverLicence">
                                                </div>
                                            </div>
                                                <input type="file" accept='image/*' style="visibility: hidden; width: 0px;" id="driver-licence" @change="previewDriverLicenceImage">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="input__pair">
                                        <p>Picture of your insurance</p>
                                        <div class="input__section">
                                            <div class="input__context">
                                                <div class="img__input__container">

                                                    <a  v-if="driverInsuranceImage.name && checkValidDoc(driverInsuranceImage.name)" :href="driverInsuranceImage.name" target="_blank" class="link__box">Insurance image</a>
                                                    <input  v-if="!driverInsuranceImage.name ||  !checkValidDoc(driverInsuranceImage.name)"  class="input-filed" placeholder="eg. image.jpg" type="text" name="insurance picture" v-model="driverInsuranceImage.name">

                                                    <img v-if="driverInsuranceImage.name === undefined || driverInsuranceImage.name.length === 0" src="./../../assets/nonUploadFile.png" alt="no-upload" class="btn-upload-file" @click="insurance">
                                                    <img v-if="driverInsuranceImage.name !== undefined && driverInsuranceImage.name.length > 0" src="./../../assets/okgreen.svg" alt="upload" class="btn-upload-file" @click="insurance">
                                                </div>
                                            </div>
                                            <input type="file" accept='image/*' style="visibility: hidden; width: 0px;" id="insurance" @change="previewDriverInsuranceImage">
                                        </div>
                                    </div>
                                    <div class="input__pair">
                                        <p>Picture of your Uber/Lyft rating</p>
                                        <div class="input__section">
                                        <div class="input__context">

                                         <div class="img__input__container">
                                            <a  v-if="driverRating.name && checkValidDoc(driverRating.name)" :href="driverRating.name" target="_blank" class="link__box">Rating image</a>
                                            <input  v-if="!driverRating.name || !checkValidDoc(driverRating.name)"  class="input-filed" placeholder="eg. image.jpg" type="text" name="side picture" v-model="driverRating.name">

                                            <img v-if="driverRating.name === undefined || driverRating.name.length === 0" src="./../../assets/nonUploadFile.png" alt="no-upload" class="btn-upload-file" @click="rating">
                                            <img v-if="driverRating.name !== undefined && driverRating.name.length > 0" src="./../../assets/okgreen.svg" alt="upload" class="btn-upload-file" @click="rating">
                                          </div>
                                         </div>
                                        <input type="file" accept='image/*' style="visibility: hidden; width: 0px;" id="rating" @change="previewDriverRating">
                                        </div>
                                    </div>
                                    <div class="input__pair">
                                        <p>Picture of the side of your car</p>
                                       <div class="input__section">
                                        <div class="input__context">

                                            <div class="img__input__container">
                                                <a  v-if="sideImage.name && checkValidDoc(sideImage.name)" :href="sideImage.name" target="_blank" class="link__box">Side image</a>
                                                <input  v-if="!sideImage.name || !checkValidDoc(sideImage.name)"  class="input-filed" placeholder="eg. image.jpg" type="text" name="side picture" v-model="sideImage.name">

                                                <img v-if="sideImage.name === undefined || sideImage.name.length === 0" src="./../../assets/nonUploadFile.png" alt="no-upload" class="btn-upload-file" @click="sidePicture">
                                                <img v-if="sideImage.name !== undefined && sideImage.name.length > 0" src="./../../assets/okgreen.svg" alt="upload" class="btn-upload-file" @click="sidePicture">
                                            </div>

                                        </div>
                                        <input type="file" accept='image/*' style="visibility: hidden; width: 0px;" id="side-picture" @change="previewSideImage">
                                        </div>
                                    </div>
                                    <projector-section v-if="idLeftProjector" :idProjector="idLeftProjector">
                                        Left projector
                                    </projector-section>
                                    <projector-section v-if="idRightProjector" :idProjector="idRightProjector">
                                        Right projector
                                    </projector-section>
                                </div>
                            </div>
                        </div>
                        <div class="driver__sub__container">
                            <div class="terms__container">
                                <div>
                                    <input type="checkbox" name="adway-notification" id="adway-notification" v-model="notifications"/>
                                    <label for="adway-notification">I want to receive Adway's notifications</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="driver__information box__container box-shadow">
                    <p class="header">DRIVING DATA</p>
                    <div class="filters__container">
                        <p class="header">FILTER</p>
                        <div class="filters__row flex row tablet__display">
                            <div class="filter__section">
                                <v-date-picker mode="single" :masks="{ input: ['MM-DD-YYYY']}" :input-props='{class: "datepicker"}' v-model="filters.start_date" />
                                <el-time-picker
                                    v-model="filters.start_time"
                                    selectableRange="00:00 - 12:59"
                                    format="hh:mm A"
                                    value-format="HH:mm">
                                </el-time-picker>
                            </div>
                        </div>
                        <div class="filters__row flex row tablet__display">
                        <div class="filter__section">
                            <v-date-picker mode="single" :masks="{ input: ['MM-DD-YYYY']}" :input-props='{class: "datepicker"}' v-model="filters.end_date" />
                            <el-time-picker
                                v-model="filters.end_time"
                                selectableRange="00:00 - 12:59"
                                format="hh:mm A"
                                value-format="HH:mm">
                            </el-time-picker>
                            <p class="apply-btn" @click="setFilteredStats(null)">
                                <template v-if="!loading">Apply</template>
                                <clip-loader color="white" size="15px" :loading="loading" />
                            </p>
                            </div>
                    </div>
                        </div>

                    <heatmap
                      v-if="driverHeatMapPoints"
                      class="drivers-heatmap"
                      :initialPoints="driverHeatMapPoints"
                      :needBound="driverHeatMapPointsNeedBound"
                      @zoom-changed="zoomChanging"
                    />

                    <div class="chart__labels__holder" style="margin-top: 25px;">
                       <div class="chart__total__holder">TOTAL: <span>{{this.totalFixed}}</span></div>
                        <div class="chart__type__holder">
                            <p :class="{'active__chart__label': filteredChartType === 'impressions'}" @click="setFilteredChartType('impressions')">Impressions</p>
                            <p :class="{'active__chart__label': filteredChartType === 'duration'}" @click="setFilteredChartType('duration')">Display Duration</p>
                            <p :class="{'active__chart__label': filteredChartType === 'campaigns'}" @click="setFilteredChartType('campaigns')"># Of Campaigns</p>
                        </div>

                        <div class="chart__duration__holder">
                            <p :class="{'active__chart__label': filteredChartDuration === 'hours'}" @click="setFilteredChartDuration('hours')">Hours</p>
                            <p :class="{'active__chart__label': filteredChartDuration === 'days'}" @click="setFilteredChartDuration('days')">Days</p>
                        </div>
                    </div>

                    <div class="driver__chart__container chart">
                        <apexchart type="line" :options="filteredChartOptions" :series="filteredChartSeries"></apexchart>
                    </div>
                </div>

                <div class="driver__information box__container box-shadow">
                    <p class="header">AVERAGE DRIVING DATA AT A GLANCE</p>

                    <div class="chart__labels__holder">
                        <div class="chart__type__holder">
                            <p :class="{'active__chart__label': activeChartType === 'impressions'}" @click="setChartType('impressions')">Impressions</p>
                            <p :class="{'active__chart__label': activeChartType === 'duration'}" @click="setChartType('duration')">Display Duration</p>
                            <p :class="{'active__chart__label': activeChartType === 'campaigns'}" @click="setChartType('campaigns')"># Of Campaigns</p>
                        </div>

                        <div class="chart__duration__holder">
                            <p :class="{'active__chart__label': activeChartDuration === 'hours'}" @click="setChartDuration('hours')">Hours</p>
                            <p :class="{'active__chart__label': activeChartDuration === 'days'}" @click="setChartDuration('days')">Days</p>
                        </div>
                    </div>

                    <div class="driver__chart__container chart">
                        <apexchart type="line" :options="chartOptions" :series="chartSeries"></apexchart>
                    </div>
                </div>

                <div class="driver__information box__container financial__data box-shadow">
                    <p class="header">FINANCIAL DATA</p>

                    <div class="list__container">
                        <div class="sum__container">
                            <p>Paid Out: <span> $ {{financeDataSum}}</span></p>
                        </div>

                        <div class="list__headers">
                            <p class="transaction__col">TRANSACTION</p>
                            <p class="amount__col">AMOUNT</p>
                            <p class="date__col">DATE</p>
                        </div>

                        <div class="list__body">
                            <div class="list__item" v-for="(data, index) in financialData" v-bind:key="data.type+index">
                                <p class="transaction__col">{{ data.type }}</p>
                                <p class="amount__col">${{ data.amount }}</p>
                                <p class="date__col">{{ customMonthFormatter(data.created) }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="driver__information box__container financial__data box-shadow">
                    <p class="header">MESSAGES</p>
                    <div class="list__container">
                        <div class="list__headers">
                            <p class="message__col">MESSAGE</p>
                            <p class="sent-by__col">SENT BY</p>
                            <p class="date-message__col">DATE TIME</p>
                            <p class="status__col">STATUS</p>
                        </div>
                        <div class="list__body">
                            <div class="list__item" v-for="(data, index) in messsageData" v-bind:key="data.message+index">
                                <p class="message__col">{{ data.message }}</p>
                                <p class="sent-by__col">{{ data.sent_by }}</p>
                                <p class="date-message__col">{{ customMonthFormatter(data.timestamp) }}</p>
                                <p class="status__col">{{ data.status }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import store from '@store/index.js'
import styles from '@utils/mapStylesDark.js'
import Chart from '@utils/Chart.js'
import moment from 'moment'
import { mapGetters } from 'vuex'
import toast from '@utils/toast.js'
import HTTPRequest from '@utils/HttpRequest.js'
import Config from '@utils/Config.js'

import { ERROR_CODE_INVALID_TOKEN } from '../../constants/responseCode'

import TimePicker from '@components/partials/TimePicker.vue'
import Datepicker from 'vuejs-datepicker'
import Heatmap from '@partials/Heatmap.vue'
import ProjectorSection from '@partials/ProjectorSection.vue'
import DriverMessage from '@/components/driver/DriverMessage.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'


const defaultCenterPoint = { lat: 55.9352001, lng: -4.7766924 };

// const DRIVER_STATUSES = {
//     Registered: 1,
//     'Appointment scheduled': 2,
//     Blocked: 3,
//     Active: 4,
//   Inactive: 5
// };

export default {

    // DRIVER_STATUSES,
    name: 'DriverPopUp',
    components: {
      Datepicker,
      TimePicker,
      Heatmap,
      ProjectorSection,
      DriverMessage,
      ClipLoader
    },
    defaultCenterPoint,
    data: function () {
        return {
            loading: false,
            store: store,
            driverNotes: '',
            driverFirstname: '',
            driverSurname: '',
            driverEmail: '',
            driverPhoneNumber: '',
            driverState: '',
            driverStatus: '',
            driverInstallation: '',
            driverLastAppointment: '',
            initLabelLastAppointment: '',
            initDateLastAppointment: '',
            driverCity: '',
            driverRegistration: '',
            idLeftProjector: '',
            idRightProjector: '',
            driverPassword: '',
            carBrand: '',
            carModel: '',
            carModels: [],
            carYear: '',
            colorDropdown: false,
            userUpdated:{},
            colors: '',
            driverHours: '',
            timeFlags: [],
            platformFlags: [],
            timeIndex: [],
            platformIndex: [],
            driverLicenceImage: {name: '', flag: false, file: null},
            driverInsuranceImage: {name: '', flag: false, file: null},
            driverRating: {name: '', flag: false, file: null},
            sideImage:  {name: '', flag: false, file: null},
            notificationCB: false,
            styles,
            chartOptions: {},
            chartSeries: [],
            chart: {
                days: [],
                hours: []
            },
            activeChartType: '',
            activeChartDuration: '',
            financialData: [],
            messsageData: [],
            filters: {
                start_date: moment(moment().subtract(1, 'months').format('MM-DD-YYYY'), 'MM-DD-YYYY').toDate(),
                end_date: moment(moment().format('MM-DD-YYYY'), 'MM-DD-YYYY').toDate(),
                start_time: '00:00:00',
                end_time: '00:00:00'
            },
            filteredChartOptions: {},
            filteredChartSeries: [],
            filteredChart: {
                days: [],
                hours: []
            },
            filteredChartType: '',
            filteredChartDuration: '',
            heatMapLayer: null,
            selectedColorRGB: '',
            selectedColorName: '',
            currentYear: new Date().getFullYear(),
            notifications: false,
            financeDataSum: 0,
            totalChart: 0,
            totalfilteredChart: 0,
            config: Config,
            driverHeatMapPoints: null,
            driverHeatMapPointsNeedBound: false,
            cities: [],
        }
    },
    props: {
        driver: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    methods: {
        checkValidDoc(imageName){
            if (imageName.startsWith("https://adwayusa.s3.amazonaws.com/documents")){
                return true
            }else{
                return false
            }
        },
        checkCarBrand () {
            this.store.state.schema.car_models.forEach(car => {
                if (car.Make === this.carBrand) {
                    this.carModels = car.Models
                }
            })
        },
        checkStateCities () {
            store.state.schema.US.forEach(us => {
                if (us.state === this.driverState) {
                this.cities = us.cities
                }
            })
        },
        selectDriverStatus(status) {
            this.driverStatus = this.store.state.schema.driver_statuses.find(ds => ds.name === status)?.id
        },
        carYearRangeValue () {
            if (this.carYear > this.currentYear) {
                this.carYear = this.currentYear
            }
        },
        toggleDropdown () {
            this.colorDropdown = !this.colorDropdown
        },
        selectedColor (rgb, name) {
            this.selectedColorRGB = rgb
            this.selectedColorName = name
            this.toggleDropdown()
        },
        checkSelectedColorByRGB (RGB) {
            this.colors.map(color=>{
                if(color.RGB === RGB){
                    this.selectedColorName = color.name
                    this.selector()
                }
            })
        },
        selector () {
            if (!this.selectedColorName) {
                return 'Color'
            } else {
                return `<span style="background: ${this.selectedColorRGB}"></span> ${this.selectedColorName}`
            }
        },
        drivingHourRangeValue () {
            if (this.driverHours > 80) {
                this.driverHours = 80
            }
            if (this.driverHours < 0) {
                this.driverHours = 0
            }
        },
        changeFlagValue (item, index) {
            if (index === 1) {
                this.timeFlags.splice(item, 1, !this.timeFlags[item])
            } else if (index === 2) {
                this.platformFlags.splice(item, 1, !this.platformFlags[item])
            }
        },
        driverLicence () {
            document.getElementById('driver-licence').click()
        },
        insurance () {
            document.getElementById('insurance').click()
        },
        rating () {
            document.getElementById('rating').click()
        },
        sidePicture () {
            document.getElementById('side-picture').click()
        },
        previewDriverLicenceImage (event) {
            this.driverLicenceImage.file = event.target.files[0]
            this.driverLicenceImage.name = this.driverLicenceImage.file.name
            this.driverLicenceImage.flag = true
            },
        previewDriverInsuranceImage (event) {
            this.driverInsuranceImage.file = event.target.files[0]
            this.driverInsuranceImage.name = this.driverInsuranceImage.file.name
            this.driverInsuranceImage.flag = true
            },
         previewDriverRating (event) {
            this.driverRating.file = event.target.files[0]
            this.driverRating.name = this.driverRating.file.name
            this.driverRating.flag = true
            },
        previewSideImage (event) {
            this.sideImage.file = event.target.files[0]
            this.sideImage.name = this.sideImage.file.name
            this.sideImage.flag = true
            },
        setStats() {
            var url = '/admin/get/driver/stats'
            var body = {
                data: {
                    driver_id: this.driver.id
                }
            }

            this.request(url, 'POST', body).then(response=>{
                if (response.code === 0) {
                    this.chart.days = response.data.displays_by_weekday
                    this.chart.hours = response.data.displays_by_hour
                    this.financialData = response.data.financials
                    this.messsageData = response.data.messages
                    // this.calculatePayment()
                    this.setChart()
                } else {
                    if (response.code === ERROR_CODE_INVALID_TOKEN) {
                        this.checkTokenConditions(this.setStats)
                    }
                }
            })
        },
        sendDriverMessage() {
            this.setStats()
        },

        fetchFilteredStats(zoom) {
            var url = '/admin/get/driver/stats'
            var from = moment(this.filters.start_date).format("YYYY-MM-DD") + " " + this.filters.start_time
            var till = moment(this.filters.end_date).format("YYYY-MM-DD") + " " + this.filters.end_time

            var body = {
                data: {
                    driver_id: this.driver.id,
                    zoom,
                    from,
                    till,
                }
            }

            return this.request(url, 'POST', body)
        },

        setFilteredStats (zoom) {
            this.loading = true
            this.fetchFilteredStats(zoom).then(response => {
                this.loading = false
                if (response.code === 0) {
                    this.filteredChart.days = response.data.displays_by_weekday
                    this.filteredChart.hours = response.data.displays_by_hour
                    this.setFilteredChart()

                    this.driverHeatMapPoints = response.data.points?.coordinates || []
                    this.driverHeatMapPointsNeedBound = !zoom
                } else {
                    toast.errorMessage(response.message)
                    if (response.code === ERROR_CODE_INVALID_TOKEN) {
                        this.checkTokenConditions(this.setFilteredStats)
                    }
                }
            })
        },

        setChart() {
            this.activeChartType = 'duration'
            this.activeChartDuration = 'days'
            this.changeChartData()
        },
        setFilteredChart() {
            this.filteredChartType = 'duration'
            this.filteredChartDuration = 'days'
            this.changeFilteredChartData()
        },
        setChartType(type){
            this.activeChartType = type
            this.changeChartData()
        },
        setChartDuration(duration){
            this.activeChartDuration = duration
            this.changeChartData()
        },
        setFilteredChartType(type){
            this.filteredChartType = type
            this.changeFilteredChartData()
        },
        setFilteredChartDuration(duration){
            this.filteredChartDuration = duration
            this.changeFilteredChartData()
        },
        changeChartData() {
            let categories = []
            let series = []

            this.chart[this.activeChartDuration].map(obj=>{
                categories.push(obj[this.activeChartDuration.replace("s", "")])
                series.push(obj[this.activeChartType])
            })

            this.chartSeries = Chart.getChartSeries("driver-chart-series", series)
            if(this.isMobile()){
                this.chartOptions = Chart.getChartOptions("driver-chart-categories", categories, true)
            } else {
                this.chartOptions = Chart.getChartOptions("driver-chart-categories", categories)
            }
        },
        changeFilteredChartData() {
            let categories = []
            let series = []
            this.totalChart = 0

            this.filteredChart[this.filteredChartDuration].map(obj=>{
                categories.push(obj[this.filteredChartDuration.replace("s", "")])
                series.push(obj[this.filteredChartType])
                this.totalChart += obj[this.filteredChartType]
            })

            this.filteredChartSeries = Chart.getChartSeries("driver-chart-series", series)
            if(this.isMobile()){
                this.filteredChartOptions = Chart.getChartOptions("driver-chart-categories", categories, true)
            } else {
                this.filteredChartOptions = Chart.getChartOptions("driver-chart-categories", categories)
            }
        },
        startTimeChange (time) {
            this.filters.start_time = time
        },
        endTimeChange (time) {
            this.filters.end_time = time
        },
        getProfile () {
            var body = {
                data: {
                    driver_id: this.driver.id
                }
            }
            this.request('/admin/get/driver', 'POST', body).then( response => {
                if ( response.code === 0 ) {
                    this.setParameters(response.data)
                    this.checkCarBrand()
                } else {
                    if (response.code === ERROR_CODE_INVALID_TOKEN){
                        this.checkTokenConditions(this.popUpDriver())
                    }
                }
            }).catch(error => {
            })
        },
        setFlagsArray () {
            var self = this

            //check if timeIndex and platform index are not null, otherwise the checkCarBrand is not called after setParameters

            if(this.timeIndex !== null){
                this.store.state.schema.ride_time.forEach(element => {
                    self.timeFlags.push(false)
                })
                this.timeIndex.forEach(element => {
                    self.timeFlags[self.store.state.schema.ride_time.indexOf(element)] = true
                })
            }
            if(this.platformIndex !== null){
                this.store.state.schema.transportation_platform.forEach(element => {
                    self.platformFlags.push(false)
                })

                this.platformIndex.forEach(element => {
                    self.platformFlags[self.store.state.schema.transportation_platform.indexOf(element)] = true
                })
            }


        },
        setParameters (data) {
            //User profile
            this.colors = this.store.state.schema.colors
            this.driverFirstname = data.firstname === null ? '' : data.firstname
            this.driverSurname = data.surname === null ? '' : data.surname
            this.driverEmail = data.email === null ? data.user === null ? '' : data.user.includes('@') ? data.user : '' : data.email
            this.driverPhoneNumber = data.phone === null ? '' : data.phone
            this.financeDataSum = data.payout
            this.driverRegistration = data.registration || ''
            this.driverNotes = data.notes || ''
            this.selectDriverStatus(data.status)
            this.driverState = data.state || ''
            this.driverInstallation = data.installation || ''
            this.checkStateCities()
            this.driverCity = data.city || ''
            this.driverLastAppointment = data.last_appointment_date ? moment(data.last_appointment_date)._d : ''
            this.initDateLastAppointment = this.driverLastAppointment
            this.initLabelLastAppointment = data.last_appointment_label || ''
            this.idLeftProjector = data.left_projector || ''
            this.idRightProjector = data.right_projector || ''

            //car details
            this.carBrand = data.car_make === null ? '' : data.car_make
            this.carModel = data.car_model === null ? '' : data.car_model
            this.carYear = data.car_year === null ? '' : data.car_year
            this.selectedColorRGB = data.car_color
            this.checkSelectedColorByRGB(data.car_color);
            //Drive details
            this.driverHours = data.driving_per_week
            this.timeIndex = data.ride_time
            this.platformIndex = data.platforms
            //Document details
            this.driverLicenceImage.name = data.license_picture ?  data.license_picture : ''
            this.driverLicenceImage.flag = data.license_picture
            this.driverInsuranceImage.name = data.insurance_picture ? data.insurance_picture : ''
            this.driverInsuranceImage.flag = data.insurance_picture
            this.driverRating.name = data.rating_picture ?  data.rating_picture : ''
            this.driverRating.flag = data.rating_picture
            this.sideImage.name = data.side_picture ? data.side_picture : ''
            this.sideImage.flag =data.side_picture
            // this.driverLicenceImage = data.license_picture === null ? '' : data.license_picture
            // this.driverInsuranceImage = data.insurance_picture === null ? '' : data.insurance_picture
            // this.driverRating = data.rating_picture === null ? '' : data.rating_picture
            // this.sideImage = data.side_picture === null ? '' : data.side_picture
            //notification
            this.notifications = data.ADWAY_notifications
            this.setFlagsArray()
        },
        saveProfile() {

            var request = new HTTPRequest()
            let body = {
                user: this.driverEmail,
                code: this.token.token,
                API_KEY: this.config.api_key,
                data: {
                    driver_id: this.driver.id,
                    firstname: this.driverFirstname,
                    surname: this.driverSurname,
                    email: this.driverEmail,
                    phone: this.driverPhoneNumber,
                    car_make: this.carBrand,
                    car_model: this.carModel,
                    car_year: this.carYear,
                    car_color: this.selectedColorRGB,
                    driverHours: this.driverHours,
                    ADWAY_notifications: this.notifications,
                    ride_time: [],
                    platforms: [],
                    city: this.driverCity,
                    state: this.driverState,
                    notes: this.driverNotes,
                    status: this.driverStatus,
                    last_appointment: `${moment(this.driverLastAppointment).format('YYYY-MM-DD')}T00:00`,
                }
            }
            console.log("OBJECT: ",body)

            this.schema.ride_time.map((item, index)=>{
                if(this.timeFlags[index]){
                    body.data.ride_time.push(item)
                }
            })

            this.schema.transportation_platform.map((item, index)=>{
                if(this.platformFlags[index]){
                    body.data.platforms.push(item)
                }
            })
               console.log(body)

            // var url = this.config.address + '/admin/set/driver'
            var formData = new FormData()
            // this.driver.printData()
            formData.append('json', JSON.stringify(body))
            formData.append('driver_license_picture', this.driverLicenceImage.file)
            formData.append('insurance_picture', this.driverInsuranceImage.file)
            formData.append('rating_picture', this.driverRating.file)
            formData.append('side_picture', this.sideImage.file)
            // this.request('/admin/set/driver', 'POST', formData).then((response) => {

            this.request('/admin/set/driver', 'POST', formData).then((response) => {
                   console.log("Response",response)
                if (response.code === 0) {
                    toast.successMessage('Profile updated')
                    this.userUpdated=body;
                } else {
                    toast.errorMessage(response.messsage)
                    if (response.code === ERROR_CODE_INVALID_TOKEN) {
                        console.log(response)
                        this.checkTokenConditions(this.saveProfile)
                    }
                }
            }).catch((error) => {
                 console.log(error)
            })
        },
        checkTokenConditions (callback) {
            try{
                var expiresDate = new Date(this.token.expires)
            } catch (err) {
                this.$router.push('/login')
            }
            var now = new Date()
            if (expiresDate <= now) {
                this.store.commit('setToken', {})
                this.$router.push('/login')
            } else {
                var body = {
                code: '',
                refresh_token: this.token.refresh_token
                }
                this.request('/refresh/token', 'POST', body).then((response) => {
                if (response.code === 0 ) {
                    store.commit('setToken', response.data[0])
                    store.commit('setDriver', response.data[0].driver)
                    callback()
                } else if (response.code === ERROR_CODE_INVALID_TOKEN) {
                    this.store.commit('setToken', {})
                    this.$router.push('/login')
                }
                }).catch((error) => {
                })
            }
            var token = this.token
            token.redirect = false
            this.store.commit('setToken', token)
        },
      zoomChanging(zoom){
        this.setFilteredStats(zoom)
      }
    },
    mounted() {
        this.userUpdated={};
        this.getProfile()
        this.setStats()
        this.setFilteredStats()
    },
    computed: {
        ...mapGetters({
            schema: 'getSchema',
            user: 'getUser',
            token: 'getToken'
        }),

        totalFixed:function(){
            if(this.totalChart % 1 == 0){
              return this.totalChart;
            }
            return this.totalChart.toFixed(2);

        },

        textLastAppointment() {
            if (this.initDateLastAppointment === this.driverLastAppointment) {
                return this.initLabelLastAppointment.slice(10);
            }
           return ''
        }

    }
}
</script>

<style scoped>
@import '../../style/admin.css';

.link__box{
    border: 1px solid #CCD4E0;
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 6px rgba(81, 95, 152, 0.161);
    box-shadow: 0px 0px 6px rgba(81, 95, 152, 0.161);
    height: 35px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    padding: 10px;
    font-size: 14px;
}

.wrapper-dropdown {
    position: relative;
    width: 95%;
    background: #FFF;
    color: #2e2e2e;
    outline: none;
    cursor: pointer;
    height: 35px;
    margin-top: 5px;
}

.wrapper-dropdown > span {
	width: 100%;
	display: block;
	border: 1px solid #ababab;
  padding: 6px;
  border-radius: 6px;
}
.wrapper-dropdown > span > span {
  padding: 0 12px;
  margin-right: 5px;
}
.wrapper-dropdown > span:after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    right: 0px;
    top: calc(50% + 4px);
    margin-top: -6px;
	  border-width: 6px 6px 0 6px;
    border-style: solid;
	  border-color: #2e2e2e transparent;
}

.wrapper-dropdown .dropdown {
    position: absolute;
	  z-index: 10;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    font-weight: normal;
	  list-style-type: none;
	  padding-left: 0;
	  margin: 0;
	  border: 1px solid #ababab;
	  border-top: 0;
}

.wrapper-dropdown .dropdown li {
    display: block;
    text-decoration: none;
    color: #2e2e2e;
	  padding: 5px;
	  cursor: pointer;
}

.wrapper-dropdown .dropdown li > span {
  padding: 0 12px;
  margin-right: 5px;
}

.wrapper-dropdown .dropdown li:hover {
    background: #eee;
	  cursor: pointer;
}

.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}
.chart__total__holder{
    position:absolute;
    left: 0;
    display: flex;
    margin-top: 5px;
}
.chart__total__holder span{
    font-weight: 600;
    margin-left: 5px;
}

.drivers-heatmap {
  width: 100%;
  height: 300px;
}

  @media screen and (max-width: 1200px){
      .filter__section .el-date-editor.el-input {
        width: 188px !important;
        margin-right: 0  !important;
        }
        .chart__total__holder{
            margin: 15px 0 15px 5px;
            position:relative;
        }
    }
    @media screen and (min-width:600px) and (max-width: 1100px) {
    .filters__row{
        display: block !important;
    }
    .chart__labels__holder p {
        font-size: 13px;
    }
    .chart__labels__holder {
        flex-direction: column;
    }
    .chart__duration__holder {

        display: flex;
        margin: 15px 0 15px 0;
        position: relative;
    }
}

.driver__sub__last-container {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

.driver__sub__last-container .input__pair{
  max-width: 45%;
}
.message__col {
    width: 55%;
    text-align: left;
}
.sent-by__col {
    width: 15%;
    text-align: left;
}
.date-message__col {
    width: 15%;
    text-align: left;
}
.status__col {
    width: 15%;
    text-align: left;
}
</style>

<style>
.vdp-datepicker input, .vdp-datepicker select{
    border: 1px solid #CCD4E0;
    border-radius: 5px;
    box-shadow: 0px 0px 6px rgba(81, 95, 152, 0.161);
    height: 35px;
    box-sizing: border-box;
    padding-left: 10px;
    width: 100%;
    margin-top: 10px;
}

</style>
